import { render } from "./UserContacts.vue?vue&type=template&id=138ed2be&scoped=true&ts=true"
import script from "./UserContacts.vue?vue&type=script&lang=ts"
export * from "./UserContacts.vue?vue&type=script&lang=ts"

import "./UserContacts.vue?vue&type=style&index=0&id=138ed2be&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138ed2be"]])

export default __exports__